var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHomeMission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.902,
    height: 62.902,
    viewBox: "0 0 62.902 62.902",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dart-mission-goal-success-svgrepo-com",
    transform: "translate(-1.75 -0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3560",
    "data-name": "Path 3560",
    d: "M56.69,16.423a28.514,28.514,0,0,1,4.474,15.66A29.082,29.082,0,1,1,32.082,3a28.514,28.514,0,0,1,15.66,4.474",
    transform: "translate(0 1.237)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_477",
    "data-name": "Ellipse 477",
    cx: 14,
    cy: 13.5,
    rx: 14,
    ry: 13.5,
    transform: "translate(18 20)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    y1: 14,
    x2: 13,
    transform: "translate(33 20)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3559",
    "data-name": "Path 3559",
    d: "M39.9,10.948H30.948V2L22,10.948V19.9h8.948Z",
    transform: "translate(23.505 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHomeMission);
export default __webpack_public_path__ + "static/media/icon-home-mission.f1a803b441055ff26f188b5ca9aa649a.svg";
export { ForwardRef as ReactComponent };